export enum TipoUsuarioEnum {
    ADMINISTRADOR = 'administrador',
    ASSESSOR = 'assessor',
    ESCRITORIO = 'escritorio',
    INVESTIDOR = 'investidor'
}
